import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Check } from "@mui/icons-material";
import {
  DELETE_ANNOUNCEMENTS,
  GET_ALL_ANNOUNCEMENTS,
  UPDATE_ANNOUNCEMENTS,
} from "app/redux/actions/announcements";
import styled from "styled-components";
import dayjs from "dayjs";

function Announcements() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedInUser = useSelector((state) => state.user.user);
  const announcement = useSelector((state) => state.announcement);

  const [openDialog, setOpenDialog] = useState(false);
  const [id, setId] = useState(null);

  useEffect(() => {
    if (loggedInUser?.token) {
      dispatch(
        GET_ALL_ANNOUNCEMENTS(
          {
            page: 1,
            limit: 10,
          },
          loggedInUser.token
        )
      );
    }
  }, [dispatch, loggedInUser]);

  const handleEdit = (recordId) => {
    navigate(`/announcement/${recordId}`);
  };

  const publish = (recordId) => {
    dispatch(
      UPDATE_ANNOUNCEMENTS(
        recordId,
        {
          status: "Published",
        },
        loggedInUser.token
      )
    );
  };

  const handleDelete = (id) => {
    setId(id);
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    if (id) {
      dispatch(DELETE_ANNOUNCEMENTS(id, loggedInUser.token));
      setOpenDialog(false);
    }
  };

  const HorizontalTable = styled.div`
    overflow-x: auto;

    @media (max-width: 600px) {
      width: 350%;
      overflow-x: auto;
    }
  `;

  return (
    <SimpleCard>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Breadcrumb
          routeSegments={[
            {
              name: "All Announcements",
            },
          ]}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/announcement")}
        >
          Create Announcement
        </Button>
      </Box>

      <Box
        padding={2}
        sx={{ flexGrow: 1, overflow: "auto", paddingBottom: "70px" }}
      >
        <HorizontalTable>
          <TableContainer component={Paper} style={{ marginTop: "16px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ pl: 4 }}>Title</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Target Role</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Expires At</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {announcement.getAllLoading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : !announcement.getAll ||
                  (announcement.getAll?.announcements || []).length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No records found.
                    </TableCell>
                  </TableRow>
                ) : (
                 
                  (announcement.getAll?.announcements || []).map((record) => (
                    <TableRow key={record.id}>
                      <TableCell sx={{ pl: 4 }}>
                        {record.title || "N/A"}
                      </TableCell>
                      <TableCell>{record.message || "N/A"}</TableCell>
                      <TableCell>{record.targetRole || "All"}</TableCell>
                      <TableCell>{record?.User?.name || "-"}</TableCell>

                      <TableCell>
                        {record.expiresAt
                          ? dayjs(record.expiresAt).format("MM/DD/YYYY hh:mm A")
                          : "-"}
                      </TableCell>

                      
                      <TableCell>
                        <span
                          style={{
                            color:
                              record.status === "Expired" ? "red" : "inherit",
                          }}
                        >
                          {record.status || "-"}
                        </span>
                      </TableCell>
                   

                      <TableCell>
                        {record.status === "Draft" && (
                          <IconButton
                            onClick={() => publish(record.id)}
                            color="primary"
                            title="Publish"
                          >
                            <Check />
                          </IconButton>
                        )}

                        {record.status !== "Expired" && (
                          <IconButton
                            onClick={() => handleEdit(record.id)}
                            color="primary"
                            title="Edit"
                          >
                            <EditIcon />
                          </IconButton>
                        )}

                        <IconButton
                          onClick={() => handleDelete(record.id)}
                          color="error"
                          title="Delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </HorizontalTable>
      </Box>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this Announcement record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </SimpleCard>
  );
}

export default Announcements;
